import { render, staticRenderFns } from "./PublicKeyDialog.vue?vue&type=template&id=27a81cb2&scoped=true"
import script from "./PublicKeyDialog.vue?vue&type=script&lang=js"
export * from "./PublicKeyDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicKeyDialog.vue?vue&type=style&index=0&id=27a81cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a81cb2",
  null
  
)

export default component.exports